/*
 * Copyright (c) Nexign, JSC, 2019-2025.
 */
/**
 * Page dashboard translation constants
 *
 * @author Nikolay Sviridov
 * @version 1.34.0
 * @since 1.34.0
 */

import { ReactElement } from 'react';

import { Typography } from '@nexign/scc-ui-kit';

import Modal from '@/main/modules/modal/components/Modal';
import { ModalPopupContainerStyled } from '@/main/modules/modal/components/styled/ModalStyled';



interface IFastActionsModalProps {
    modalText: ReactElement | string;
}

export const FastActionsModal = ({ modalText }: IFastActionsModalProps) => {
    return <ModalPopupContainerStyled
        data-component={'modal-popup'}
        data-name={'fast-actions-modal'}
    >
        <Modal.Text>
            <Typography isDangerousInnerHTML>{modalText}</Typography>
        </Modal.Text>
    </ModalPopupContainerStyled>
}
